import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ThirdPartsAuthenticationList } from '~modules/thirdparts/common/entities/third-parts-authentication-list.entity';
import { ThirdPartsQontoRegateAuthenticationManualCreateUpdateRequest } from '../entities/third-parts-qonto-regate-authentication-manual-create-update-request.entity';
import { environment } from 'src/environments/environment';

@Injectable()
export class ThirdPartsQontoRegateAuthenticationService {

  constructor(private readonly http: HttpClient) { }

  public list$(): Observable<ThirdPartsAuthenticationList[]> {
    const path = `${environment.apiURL}/third-parts/qonto-regate/authentication/list`;
    return this.http.get<ThirdPartsAuthenticationList[]>(path);
  }

  public createOrUpdate$(request: ThirdPartsQontoRegateAuthenticationManualCreateUpdateRequest) {
    const url = `${environment.apiURL}/third-parts/qonto-regate/authentication`;

    return this.http.post<void>(url, request);
  }
}